// Brazilian Portuguese. Keys omitted here fall back to English (see
// src/i18n/index.js). "RPilot" is a brand name and stays untranslated.
export default {
  'common.cancel': 'Cancelar',
  'common.submit': 'Enviar',
  'common.save': 'Salvar',
  'common.create': 'Criar',
  'common.delete': 'Excluir',
  'common.close': 'Fechar',
  'common.retry': 'Tentar novamente',
  'common.confirm': 'Confirmar',
  'common.areYouSure': 'Tem certeza?',

  'chat.startConversation': 'Comece uma conversa',
  'chat.inputPlaceholder': 'Digite uma mensagem...',
  'chat.inputPlaceholderNoCredits': 'Créditos RPilot esgotados',
  'chat.creditsUsedUpFooter': 'Os créditos RPilot da sua equipe acabaram. Inicie um novo chat quando os créditos forem renovados.',
  'chat.newChat': 'Novo chat',
  'chat.useSkill': 'Usar uma skill',
  'chat.skills': 'Skills',
  'chat.loadingSkills': 'Carregando skills…',
  'chat.noSkill': 'Sem skill',
  'chat.noSkillsAvailable': 'Nenhuma skill disponível',
  'chat.appliesNextMessage': 'Vale a partir da sua próxima mensagem',
  'chat.attachImage': 'Anexar imagem',
  'chat.attachFile': 'Anexar arquivo',
  'chat.fileTooLarge': 'Arquivo muito grande (máx {size})',
  'chat.uploadFailed': 'Falha no envio',
  'chat.download': 'Baixar',
  'chat.recordVoice': 'Gravar voz',
  'chat.stopRecording': 'Parar gravação',
  'chat.stop': 'Parar',
  'chat.send': 'Enviar',
  'chat.thinking': 'Pensando…',
  'chat.thoughtProcess': 'Processo de raciocínio',
  'chat.waitingForHost': 'Aguardando o painel…',
  'chat.thinkingComplete': 'Raciocínio concluído',
  'chat.toolUsedOne': '1 ferramenta usada',
  'chat.toolsUsedCount': '{count} ferramentas usadas',
  'chat.usedNames': 'Usou {names}',
  'chat.usedToolsCount': 'Usou {count} ferramentas',
  'chat.running': 'em execução',
  'chat.details': 'Detalhes',
  'chat.arguments': 'Argumentos',
  'chat.result': 'Resultado',
  'chat.error': 'Erro',
  'chat.done': 'Concluído',
  'chat.openInNewTab': 'Abrir em nova aba',
  'chat.openInDocsSite': 'Abrir no site de documentação',
  'chat.noPageContent': 'Nenhum conteúdo disponível para esta página.',
  'chat.goodResponse': 'Boa resposta',
  'chat.badResponse': 'Resposta ruim',
  'chat.whatWentWrong': 'O que deu errado?',
  'chat.optionalFeedback': 'Comentário opcional...',

  'approval.required': 'Aprovação necessária',
  'approval.requiredCount': 'Aprovação necessária — {count} ações',
  'approval.approve': 'Aprovar',
  'approval.deny': 'Negar',
  'approval.approveAll': 'Aprovar tudo',
  'approval.approveSelected': 'Aprovar selecionadas ({count})',
  'approval.denyAll': 'Negar tudo',
  'approval.andMore': '…e mais {count}',
  'approval.approvedChip': 'Aprovado',
  'approval.deniedChip': 'Negado',
  'approval.timedOutChip': 'Expirado',
  'approval.countApproved': '{count} aprovadas',
  'approval.countDenied': '{count} negadas',
  'approval.countTimedOut': '{count} expiradas',
  'approval.timedOut': 'expirado',
  'approval.settled': 'concluído',

  'header.expand': 'Expandir',
  'header.collapse': 'Recolher',
  'header.menu': 'Menu',
  'drawer.sessions': 'Sessões',
  'drawer.skills': 'Skills',
  'drawer.settings': 'Configurações',
  'drawer.noSessions': 'Nenhuma sessão ainda',
  'drawer.chatFallbackTitle': 'Chat {id}',
  'drawer.newSkill': 'Nova skill',
  'drawer.searchSkills': 'Pesquisar skills...',
  'drawer.noSkillsMatch': 'Nenhuma skill corresponde à sua pesquisa.',
  'drawer.noSkillsYet': 'Nenhuma skill ainda. Crie uma para começar.',
  'drawer.mySkills': 'Minhas skills',
  'drawer.builtIn': 'Integradas',
  'drawer.shared': 'Compartilhadas',
  'drawer.showToolCalls': 'Mostrar chamadas de ferramentas',
  'drawer.autoAcceptEdits': 'Aceitar edições automaticamente',
  'drawer.darkMode': 'Modo escuro',
  'drawer.version': 'Versão',
  'drawer.versionCopied': 'Copiado',

  'gate.meetTitle': 'Conheça o RPilot',
  'gate.meetBody': 'O RPilot é seu assistente de IA para o RDrive. Pergunte sobre desenhos, problemas, cronogramas e dados do projeto em linguagem comum e receba respostas claras com links diretos para o app.',
  'gate.meetCta': 'Quer o RPilot para a sua equipe? Fale com nosso time de vendas',
  'gate.outOfCreditsTitle': 'Seus créditos RPilot acabaram',
  'gate.outOfCreditsBody': 'Os créditos RPilot da sua equipe acabaram. Entre em contato para renovar e continuar de onde parou.',
  'credits.title': 'Uso de créditos',
  'credits.loadFailed': 'Não foi possível carregar o uso de créditos.',
  'credits.active': 'Ativo',
  'credits.fallback': 'Reserva',
  'credits.exhausted': 'esgotado',
  'credits.noPools': 'Nenhum pool de créditos',
  'credits.daily': 'Diário',
  'credits.weekly': 'Semanal',
  'credits.monthly': 'Mensal',
  'credits.dayShort': 'D',
  'credits.weekShort': 'S',
  'credits.monthShort': 'M',
  'credits.usedNoLimit': '{label} — {spent} usados (sem limite)',
  'credits.balanceLine': 'Saldo: {balance} créditos · redefine à meia-noite {zone}',
  'credits.account': 'Conta',
  'credits.scopeProject': 'Projeto',
  'credits.scopeTeam': 'Equipe',
  'credits.scopeMixed': 'Misto',
  'credits.scopePool': 'Pool',
  'credits.messageNotSent': 'Os créditos RPilot da sua equipe acabaram, então esta mensagem não pôde ser enviada. Sua conversa foi salva.',
  'credits.contactUs': 'Fale conosco',

  'sales.contactSales': 'Falar com vendas',
  'sales.requestReceived': 'Solicitação recebida ✓',
  'sales.submitAgain': 'Enviar novamente',
  'sales.name': 'Nome',
  'sales.workEmail': 'E-mail de trabalho',
  'sales.companyTeam': 'Empresa / equipe (opcional)',
  'sales.message': 'Mensagem (opcional)',
  'sales.nameRequired': 'O nome é obrigatório',
  'sales.emailRequired': 'O e-mail de trabalho é obrigatório',
  'sales.emailInvalid': 'Insira um endereço de e-mail válido',
  'sales.thanks': 'Obrigado — nossa equipe entrará em contato.',
  'sales.alreadyReceived': 'Já recebemos sua solicitação — entraremos em contato.',
  'sales.genericError': 'Algo deu errado. Tente novamente.',
  'sales.speakWithSales': 'Fale com vendas',
  'sales.salesChatPrefill': 'Olá, gostaria de falar com a equipe de vendas sobre o RPilot para minha equipe.',


  'skill.newSkill': 'Nova skill',
  'skill.editTitle': 'Editar — {name}',
  'skill.viewTitle': '{name}',
  'skill.readOnlyHint': 'Esta é uma skill integrada mantida pela RDrive e não pode ser editada. Para personalizá-la neste projeto, crie uma skill compartilhada com o mesmo nome — ela terá prioridade aqui.',
  'skill.name': 'Nome',
  'skill.nameHint': 'identificador em kebab-case',
  'skill.nameRule': 'Deve estar em kebab-case (ex.: review-rfi)',
  'skill.shared': 'Compartilhada',
  'skill.description': 'Descrição',
  'skill.descriptionPlaceholder': 'O que esta skill faz e quando usá-la',
  'skill.required': 'Obrigatório',
  'skill.tags': 'Tags',
  'skill.tagsPlaceholder': 'Digite e pressione Enter',
  'skill.allowedTools': 'Ferramentas permitidas',
  'skill.allToolsAllowed': 'Todas as ferramentas permitidas',
  'skill.instructions': 'Instruções (Markdown)',
  'skill.contentRequired': 'O conteúdo é obrigatório',
  'skill.deleteTitle': 'Excluir skill',
  'skill.deleteMessage': 'Excluir a skill "{name}"? Isso não pode ser desfeito.',

  'picker.selectLocation': 'Selecionar local',
  'picker.searchDrawings': 'Pesquisar desenhos...',
  'picker.planViewerFailed': 'Não foi possível carregar o visualizador de plantas',
  'picker.selectDrawing': 'Selecione um desenho para visualizar',
  'picker.tapToPlace': 'Toque em um marcador de local para posicionar o problema',
  'picker.pinPlaced': 'Marcador posicionado',

  'md.bold': 'Negrito',
  'md.italic': 'Itálico',
  'md.heading': 'Título',
  'md.inlineCode': 'Código embutido',
  'md.codeBlock': 'Bloco de código',
  'md.link': 'Link',
  'md.bulletList': 'Lista com marcadores',
  'md.numberedList': 'Lista numerada',
  'md.blockquote': 'Citação',
  'md.nothingToPreview': 'Nada para pré-visualizar',
}
